import React from 'react';
import { motion } from 'framer-motion';
import { Truck, Star, MapPin, Clock, Shield, Zap, Package, Award } from 'lucide-react';

const row1 = [
  { icon: Truck,   text: '50,000+ DELIVERIES COMPLETED' },
  { icon: MapPin,  text: '250+ CITIES COVERED' },
  { icon: Star,    text: '99% CLIENT SATISFACTION' },
  { icon: Clock,   text: '24/7 SUPPORT AVAILABLE' },
  { icon: Shield,  text: '100% INSURED SHIPMENTS' },
  { icon: Zap,     text: 'SAME DAY DISPATCH' },
  { icon: Package, text: 'PART LOAD & FULL LOAD' },
  { icon: Award,   text: 'PREMIUM FLEET · ZERO DAMAGE' },
];

const row2 = [
  { icon: Truck,   text: 'DOST PLUS · BADA DOST · EICHER' },
  { icon: MapPin,  text: 'PAN-INDIA NETWORK' },
  { icon: Shield,  text: 'GPS TRACKED EVERY TRIP' },
  { icon: Star,    text: 'TRUSTED BY 500+ BUSINESSES' },
  { icon: Clock,   text: 'ON-TIME DELIVERY GUARANTEED' },
  { icon: Zap,     text: '17FT TO 32FT TRUCKS AVAILABLE' },
  { icon: Package, text: 'FMCG · INDUSTRIAL · AGRI' },
  { icon: Award,   text: 'ISO CERTIFIED OPERATIONS' },
];

const TickerItem = ({ icon: Icon, text, light }) => (
  <div className="flex items-center gap-3 mx-8 shrink-0">
    <Icon size={13} className={light ? 'text-white/70' : 'text-brand-orange'} />
    <span className={`text-[10px] font-black tracking-[0.25em] uppercase ${light ? 'text-white/80' : 'text-brand-black/60'}`}>
      {text}
    </span>
    <span className={`ml-5 ${light ? 'text-white/20' : 'text-brand-orange/30'}`}>◆</span>
  </div>
);

const Marquee = () => (
  <div className="overflow-hidden relative">
    {/* Row 1 — light bg, left scroll */}
    <div className="bg-white border-y border-black/6 py-3.5 overflow-hidden relative">
      <div className="absolute left-0 top-0 h-full w-20 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 h-full w-20 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />
      <motion.div
        className="flex"
        animate={{ x: ['0%', '-50%'] }}
        transition={{ duration: 30, repeat: Infinity, ease: 'linear' }}
      >
        {[...row1, ...row1].map((item, i) => (
          <TickerItem key={i} icon={item.icon} text={item.text} light={false} />
        ))}
      </motion.div>
    </div>

    {/* Row 2 — orange bg, right scroll */}
    <div className="bg-brand-orange py-3 overflow-hidden relative">
      <div className="absolute left-0 top-0 h-full w-20 bg-gradient-to-r from-brand-orange to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 h-full w-20 bg-gradient-to-l from-brand-orange to-transparent z-10 pointer-events-none" />
      <motion.div
        className="flex"
        animate={{ x: ['-50%', '0%'] }}
        transition={{ duration: 25, repeat: Infinity, ease: 'linear' }}
      >
        {[...row2, ...row2].map((item, i) => (
          <TickerItem key={i} icon={item.icon} text={item.text} light={true} />
        ))}
      </motion.div>
    </div>
  </div>
);

export default Marquee;
